import React from 'react';
import Modal from 'react-modal';
import '../../styles/CustomModal.css';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';
import { langText } from '../../recoil/lang';

interface ModalProps {
  isOpen: boolean;
  onCancel: () => void;
  lang: number;
}

const CustomerServiceModal: React.FC<ModalProps> = ({ isOpen, onCancel, lang }) => {
  const navigateKakaoLink = () => {
    window.location.href = 'kakaoplus://plusfriend/knockmanager';
    setTimeout(() => {
      window.location.href = 'https://pf.kakao.com/_xhbdBG/chat';
    }, 500);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      className="bottom-modal"
      closeTimeoutMS={100}
      ariaHideApp={false}
      style={{
        overlay: {
          height: '100vh',
          display: 'flex',
          alignItems: 'flex-end',
          bottom: '0',
        },
      }}>
      <Style>
        <div className="alertModalWrap">
          <div className="modalContentWrap">
            <img
              onClick={onCancel}
              className="closeIcon"
              src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
              alt="닫기 아이콘"
            />
            <h2>{langText.zero_complaint_policy[lang]}</h2>
            <h1>{langText.zero_label[lang]}</h1>
            <div className="noticeBox">
              <h2>{langText.refund_policy[lang]}</h2>
            </div>
            <p>{langText.customer_service_message[lang]}</p>
            <div className="linkButtonWrap">
              <button onClick={navigateKakaoLink}>
                <h3>{langText.kakaotalk_link[lang]}</h3>
                <div className="contentDetail">
                  <img
                    className="kakaoIcon"
                    src={`${process.env.PUBLIC_URL}/svg/ic_kakao.svg`}
                    alt="카카오톡 아이콘"
                  />
                  <img
                    className="arrowIcon"
                    src={`${process.env.PUBLIC_URL}/svg/ic_arrow_right.svg`}
                    alt="이동 버튼 아이콘"
                  />
                </div>
              </button>
              <button>
                <h3>E-MAIL</h3>
                <div className="customerType">
                  <h2>knockcs@ivid.kr</h2>
                </div>
              </button>
            </div>
            <h4>{langText.food_inquiry_message[lang]}</h4>
            <button onClick={onCancel} className="closeButton">
              {langText.confirmation[lang]}
            </button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default CustomerServiceModal;
const Style = styled.div`
  h1 {
    margin: 4px 0 10px 0;
    font-size: 60px;
    font-weight: 700;
    color: #555;
  }
  h2 {
    font-size: 16px;
    font-weight: 500;
    color: #555;
  }
  h3 {
    font-size: 13px;
    font-weight: 500;
    color: #737373;
  }
  h4 {
    margin-top: 9px;
    font-size: 12px;
    font-weight: 400;
    color: #4dd2ae;
  }
  p {
    margin: 12px 0 14px 0;
    font-size: 12px;
    font-weight: 300;
    color: #979797;
    line-height: 17px;
  }

  .modalContentWrap {
    width: 100vw;
    height: 85vh;
    position: relative;
    padding: 24px 3vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: #fff;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
  }
  .noticeBox {
    padding: 4px 20px;
    border: 1px solid #4dd2ae;
    border-radius: 6px;

    h2 {
      color: #4dd2ae;
      line-height: 24px;
    }
  }
  .linkButtonWrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5%;

    button {
      flex: 1;
      min-height: 130px;
      max-height: 130px;
      padding: 14px 0 20px 0;
      border: 1px solid #979797;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    h3 {
      margin-bottom: auto;
      white-space: nowrap;
    }
    h2 {
      color: #a7a7a7;
    }
    .customerType {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .contentDetail {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      justify-content: center;
      width: 100%;
      position: relative;

      .kakaoIcon {
      }
      .arrowIcon {
        position: absolute;
        right: 0;
        top: 0;
        /* margin-left: auto; */
      }
    }
  }

  .closeButton {
    width: 100%;
    margin: 16px 0;
    padding: 14px 0;
    background: #4dd2ae;
    border-radius: 10px;
    font-size: 20px;
    font-weight: 600;
    color: #fff;
  }
`;
